import React from 'react';
import * as S from './legalStyles';

const PrivacyContentKo: React.FC = () => (
  <>
    <section style={S.section}>
      <h2 style={S.h2}>1. 개인정보의 수집 및 이용 목적</h2>
      <p style={S.p}>Freematch(이하 "회사")는 다음의 목적을 위해 개인정보를 수집하고 이용합니다:</p>
      <ul style={S.ul}>
        <li>회원 가입 및 관리: 회원제 서비스 이용에 따른 본인 확인, 회원자격 유지·관리</li>
        <li>서비스 제공: 프리랜서-의뢰인 매칭, 채팅, 결제 등 서비스 제공</li>
        <li>마케팅 및 광고 활용: 맞춤형 광고 제공, 이벤트 정보 안내</li>
        <li>서비스 개선: 서비스 이용 기록 분석을 통한 서비스 개선</li>
      </ul>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>2. 수집하는 개인정보 항목</h2>
      <p style={S.p}>
        <strong>필수 항목:</strong> 이메일, 비밀번호, 이름, 닉네임<br/>
        <strong>선택 항목:</strong> 전화번호, 생년월일, 성별, 프로필 이미지<br/>
        <strong>자동 수집:</strong> IP 주소, 쿠키, 서비스 이용 기록, 접속 로그
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>3. 개인정보의 보유 및 이용 기간</h2>
      <p style={S.p}>
        회원 탈퇴 시까지 보유하며, 탈퇴 후 즉시 파기합니다. 단, 관계 법령에 따라 보존이 필요한 경우 해당 기간 동안 보관합니다:
      </p>
      <ul style={S.ul}>
        <li>전자상거래법에 따른 계약 및 청약철회 기록: 5년</li>
        <li>대금결제 및 재화 공급 기록: 5년</li>
        <li>소비자 불만 및 분쟁처리 기록: 3년</li>
        <li>접속 로그: 3개월 (통신비밀보호법)</li>
      </ul>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>4. 개인정보의 제3자 제공</h2>
      <p style={S.p}>회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 다만, 다음의 경우에는 예외로 합니다:</p>
      <ul style={S.ul}>
        <li>이용자가 사전에 동의한 경우</li>
        <li>법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 요청이 있는 경우</li>
      </ul>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>5. 개인정보 처리 위탁</h2>
      <p style={S.p}>회사는 서비스 제공을 위해 다음과 같이 개인정보 처리를 위탁하고 있습니다:</p>
      <ul style={S.ul}>
        <li>토스페이먼츠 주식회사: 결제 처리</li>
      </ul>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>6. 이용자의 권리와 행사 방법</h2>
      <p style={S.p}>
        이용자는 언제든지 개인정보 열람, 정정, 삭제, 처리정지를 요청할 수 있습니다.
        프로필 페이지에서 직접 수정하거나, 고객센터(kunkong.co@gmail.com)로 문의해 주세요.
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>7. 개인정보 보호책임자 및 사업자 정보</h2>
      <p style={S.p}>
        <strong>담당자:</strong> KUNKONG<br/>
        <strong>이메일:</strong> kunkong.co@gmail.com<br/>
        <strong>상호:</strong> KUNKONG<br/>
        <strong>대표자:</strong> 박기범<br/>
        <strong>사업자등록번호:</strong> 306-38-75095<br/>
        <strong>주소:</strong> 경기도 화성시 왕배산1길 3-4, 3층<br/>
        <strong>대표전화:</strong> 010-6284-2450
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>8. 쿠키 사용</h2>
      <p style={S.p}>
        회사는 로그인 유지 및 서비스 개선을 위해 쿠키를 사용합니다.
        브라우저 설정에서 쿠키를 거부할 수 있으나, 일부 서비스 이용이 제한될 수 있습니다.
      </p>
    </section>

    <section style={S.section}>
      <h2 style={S.h2}>9. 개인정보처리방침 변경</h2>
      <p style={S.p}>
        이 개인정보처리방침은 법령 및 방침에 따라 변경될 수 있으며, 변경 시 웹사이트 공지사항을 통해 안내드립니다.
      </p>
    </section>
  </>
);

export default PrivacyContentKo;
